const KEYS = { LEFT: 37, UP: 38, RIGHT: 39, DOWN: 40 };

import _ from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';

import { cjsItem } from './../cjsRoot/cjsBase';

export class cjsMaze extends cjsItem {
  constructor(obj) {
    super(obj);
  }

  stageMouseClick(e, data) {
    console.log('cjsMaze: CLICK');

    e.stopPropagation();
  }
}

cjsMaze.beforeDestroy = function(stage) {
  console.log('cjsMaze: beforeDestroy');

  window.removeEventListener('keydown', stage.listener.kd, false);
  window.removeEventListener('keyup', stage.listener.ku, false);
};

cjsMaze.defineKeys = function(stage) {
  stage.listener.kd = function(e) {
    e = !e ? window.event : e;
    switch (e.keyCode) {
      case KEYS.LEFT:
        stage.keys.left = true;
        break;
      case KEYS.UP:
        stage.keys.up = true;
        break;
      case KEYS.RIGHT:
        stage.keys.right = true;
        break;
      case KEYS.DOWN:
        stage.keys.down = true;
        break;
    }

    e.stopPropagation();
  };

  stage.listener.ku = function(e) {
    e = !e ? window.event : e;
    switch (e.keyCode) {
      case KEYS.LEFT:
        stage.keys.left = false;
        break;
      case KEYS.UP:
        stage.keys.up = false;
        break;
      case KEYS.RIGHT:
        stage.keys.right = false;
        break;
      case KEYS.DOWN:
        stage.keys.down = false;
        break;
    }
    e.stopPropagation();
  };

  window.addEventListener('keydown', stage.listener.kd);
  window.addEventListener('keyup', stage.listener.ku);
};
